import { toSignInViewModel } from '@apis/responseTransformer';
import { ResponseCode, LoginRequest, OtpType, CaptchaInfo, OtpInfo } from '@ul/api';

function sendResponse(responseCode: ResponseCode) {
    const captchaInfo: CaptchaInfo = {
        captchaType: 'recaptcha',
        apiKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    };
    const otpInfo: OtpInfo = {
        otpType: OtpType.Phone,
        token: 'mock-otp-token',
        target: 'mock-otp-target',
    };

    let success = false;
    let message = 'error';
    let fillCaptchaInfo = false;
    let fillOtpInfo = false;

    switch (responseCode) {
        case ResponseCode.NeedCaptcha:
            message = 'need captcha';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.NeedOtp:
            message = 'need otp';
            fillOtpInfo = true;
            break;
        case ResponseCode.NeedPhoneAssociation:
            message = 'need phone association';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.CaptchaVerificationFailed:
            message = 'captcha failed';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.OtpVerificationFailed:
            message = 'otp failed';
            fillOtpInfo = true;
            break;
        case ResponseCode.PhoneAssociationFailed:
            message = 'phone association failed';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.UsernameExists:
            message = 'phone already exists';
            fillCaptchaInfo = true;
            break;
        case ResponseCode.ErrorOccurred:
            message = 'internal error';
            break;
        case ResponseCode.RequestTimeout:
            message = 'request timeout';
            break;
        case ResponseCode.NetworkError:
            message = 'network error';
            break;
        case ResponseCode.ClientBadRequest:
            message = 'client bad request';
            break;
        case ResponseCode.ClientNotFound:
            message = 'client not found';
            break;
        case ResponseCode.PasswordIsInCorrect:
            message = 'username or password is incorrect';
            break;
        case ResponseCode.MagicLinkSent:
            message = 'login with magiclink';
            break;
        default:
            success = true;
            message = 'successfully login';
            break;
    }

    return Promise.resolve(
        toSignInViewModel({
            success,
            message,
            responseCode,
            captchaInfo: fillCaptchaInfo ? captchaInfo : undefined,
            otpInfo: fillOtpInfo ? otpInfo : undefined,
        })
    );
}

export const signInWithMockEmail = (signInRequest: LoginRequest) => {
    const username = signInRequest.credentials.username;
    switch (username) {
        case 'china.phone_association@mock.com':
            if (!!signInRequest.otpVerifyInfo) {
                return sendResponse(ResponseCode.Successful);
            }

            if (!!signInRequest.phoneAssociationInfo?.nationalNumber) {
                return sendResponse(ResponseCode.NeedOtp);
            }

            return sendResponse(ResponseCode.NeedPhoneAssociation);
        case 'china.force_captcha@mock.com':
            if (!!signInRequest.otpVerifyInfo) {
                return sendResponse(ResponseCode.Successful);
            }

            if (!!signInRequest.phoneAssociationInfo?.nationalNumber) {
                return sendResponse(ResponseCode.NeedOtp);
            }

            if (!!signInRequest.captchaVerifyInfo) {
                return sendResponse(ResponseCode.NeedPhoneAssociation);
            }

            return sendResponse(ResponseCode.NeedCaptcha);
        case 'phone_asso.otp_failed@mock.com':
            if (!!signInRequest.otpVerifyInfo) {
                return sendResponse(ResponseCode.OtpVerificationFailed);
            }

            if (!!signInRequest.phoneAssociationInfo?.nationalNumber) {
                return sendResponse(ResponseCode.NeedOtp);
            }

            return sendResponse(ResponseCode.NeedPhoneAssociation);
        case 'phone_asso.captcha_failed@mock.com':
            if (!!signInRequest.phoneAssociationInfo?.nationalNumber) {
                return sendResponse(ResponseCode.CaptchaVerificationFailed);
            }

            return sendResponse(ResponseCode.NeedPhoneAssociation);
        case 'phone_asso.phone_exist@mock.com':
            if (!!signInRequest.phoneAssociationInfo?.nationalNumber) {
                return sendResponse(ResponseCode.UsernameExists);
            }

            return sendResponse(ResponseCode.NeedPhoneAssociation);
        case 'phone_asso.phone_failed@mock.com':
            if (!!signInRequest.otpVerifyInfo) {
                return sendResponse(ResponseCode.PhoneAssociationFailed);
            }
            if (!!signInRequest.phoneAssociationInfo?.nationalNumber) {
                return sendResponse(ResponseCode.NeedOtp);
            }

            return sendResponse(ResponseCode.NeedPhoneAssociation);
        case 'need.captcha@mock.com':
            if (!!signInRequest.captchaVerifyInfo) {
                return sendResponse(ResponseCode.Successful);
            }
            return sendResponse(ResponseCode.NeedCaptcha);
        case 'captcha.failed@mock.com':
            if (!!signInRequest.captchaVerifyInfo) {
                return sendResponse(ResponseCode.CaptchaVerificationFailed);
            }

            return sendResponse(ResponseCode.NeedCaptcha);
        case 'error@mock.com':
            return sendResponse(ResponseCode.ErrorOccurred);
        case 'timeout@mock.com':
            return sendResponse(ResponseCode.RequestTimeout);
        case 'network@mock.com':
            return sendResponse(ResponseCode.NetworkError);
        case 'badrequest@mock.com':
            return sendResponse(ResponseCode.ClientBadRequest);
        case 'notfound@mock.com':
            return sendResponse(ResponseCode.ClientNotFound);
        case 'incorrect@mock.com':
            return sendResponse(ResponseCode.PasswordIsInCorrect);
        case 'magiclink@mock.com':
            return sendResponse(ResponseCode.MagicLinkSent);
        default:
            return sendResponse(ResponseCode.Successful);
    }
};

export const signInWithMockPhone = (signInRequest: LoginRequest) => {
    const username = signInRequest.credentials.username;
    switch (username) {
        case '+66110012345':
            if (!!signInRequest.captchaVerifyInfo) {
                return sendResponse(ResponseCode.Successful);
            }

            return sendResponse(ResponseCode.NeedCaptcha);
        case '+66200012345':
            return sendResponse(ResponseCode.ErrorOccurred);
        case '+6630012345':
            return sendResponse(ResponseCode.PasswordIsInCorrect);
        default:
            return sendResponse(ResponseCode.Successful);
    }
};
